import { render, staticRenderFns } from "./undernet.vue?vue&type=template&id=765a38b3&"
import script from "./undernet.vue?vue&type=script&lang=js&"
export * from "./undernet.vue?vue&type=script&lang=js&"
import style0 from "./undernet.vue?vue&type=style&index=0&id=765a38b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports